import React from 'react';
import stopvioLogo from '../assets/images/stopvio/stopvio-logo-main.png';
import no2harmLogo from '../assets/images/no2harm/no2harm-logo-main.png';

/**
 * Logo component that displays the appropriate logo based on the domain
 */
function Logo() {
  // Check if we're on the no2harm.com domain or any subdomain
  const isNo2Harm = window.location.hostname === 'no2harm.com' || 
                     window.location.hostname === 'www.no2harm.com' ||
                     window.location.hostname.includes('no2harm.com') ||
                     window.location.hostname.includes('no2harm');
  
  // Use the appropriate logo based on the domain
  const logoSrc = isNo2Harm ? no2harmLogo : stopvioLogo;
  const altText = isNo2Harm ? 'No2Harm' : 'StopVio';
  
  return (
    <div className="site-logo">
      <img 
        src={logoSrc} 
        alt={altText} 
        style={{ 
          maxWidth: '200px', 
          height: 'auto',
          margin: '0 auto 1rem auto',
          display: 'block'
        }} 
      />
    </div>
  );
}

export default Logo;